<template>
  <div class="price-detail">
    <div class="item-layout">
      <div class="item-common-layout">
        <div class="item-common-content">
          <div class="block" @click="showExpect">
            <label class="label-ui"
              >{{ expect.label
              }}<span class="red" style="color: red">*</span></label
            >
            <div class="item-cell-bd">
              <div class="default" v-if="!expect.value">
                {{ expect.placeholder }}
              </div>
              <div v-else>
                <p>{{ expect.value }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="icon-arr-r"></div>
      </div>
    </div>
    <div class="item-layout" v-if="!isAuthPregant">
      <div class="item-common-layout">
        <div class="item-common-content">
          <div class="block">
            <label class="label-ui"
              >服务顾问<span class="red" style="color: red">*</span></label
            >
            <div class="item-cell-bd ye-gw-ui">
              <label :class="{ hasValue: !!fillIn.inviteCode }">
                <input
                  type="number"
                  placeholder="请填写育儿顾问工号"
                  maxlength="10"
                  @input="handleghInput($event)"
                  v-input-scroll
                  :value="fillIn.inviteCode"
                />
                <p class="gw-name">{{ fillIn.inviteName }}</p>
              </label>
            </div>
          </div>
        </div>
        <!-- <div class="icon-arr-r"></div> -->
      </div>
    </div>
    <div class="item-layout user-remark-layout-auth" v-if="isAuthPregant">
      <div class="item-common-layout-auth">
        <label class="label-ui"
          >服务顾问<span class="red" style="color: red">*</span></label
        >
        <span
          v-for="(item, index) in checkList"
          class="select-label"
          :key="index"
          @click="selectThis(index)"
        >
          <img
            width="18"
            height="18"
            :src="item.sign == selected ? selectImg : noSelectImg"
          />
          <span>{{ item.tips }}</span>
        </span>
        <div class="ye-gw-ui">
          <label :class="{ hasValue: !!fillIn.inviteCode }">
            <input
              :disabled="selected === 'exclusive'"
              type="number"
              placeholder="请填写育儿顾问工号"
              maxlength="10"
              @input="handleghInput($event)"
              v-input-scroll
              :value="fillIn.inviteCode"
            />
            <p class="gw-name">{{ fillIn.inviteName }}</p>
          </label>
        </div>
      </div>
    </div>
    <div class="item-layout user-remark-layout">
      <div class="item-common-layout user-remark">
        <div class="item-common-content">
          <div class="block">
            <label class="label-ui">备注<span class="fff">(选填)</span></label>
            <textarea
              placeholder="请输入您的需求"
              v-model="fillIn.remark"
              v-input-scroll
              rows="3"
              @blur="handleLabel($event)"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <mt-datetime-picker
      ref="picker"
      v-model="pickerVisible"
      type="date"
      :startDate="startDate"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      @confirm="handlePicker"
    >
    </mt-datetime-picker>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { DatetimePicker } from 'mint-ui'
import http from '@/plugins/http'
import utils from '@/plugins/utils'
import noSelectImg from '../../assets/images/icon-单选框-未选中@3x.png'
import selectImg from '../../assets/images/icon-单选框-选中@3x.png'

import { trackClick } from '@/router/confirmYuesao/ys_ensure_service_tracker'
const userInfoUrl = `${utils.hostname('user')}/user/GetUserInfo` // 获取用户的专属育儿顾问名字
const pregantAuthStatusUrl = 'https://user.cekid.com/user/GetPregantAuthStatus'
const codeUrl = 'https://svsfk.czj100.com/svsfk-web/empRef/getSimEmpEnlInfo.do'
// const codeUrl = 'https://subscriber.haiziwang.com/subscriber-web/empRef/getSimEmpEnlInfo.do'
export default {
  components: {
    [DatetimePicker.name]: DatetimePicker
  },
  props: {
    fillIn: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      pickerVisible: null,
      startDate: new Date(),
      isAuthPregant: false,
      noSelectImg: noSelectImg,
      selectImg: selectImg,
      selected: 'exclusive',
      checkList: [
        {
          sign: 'exclusive',
          tips: '专属育儿顾问',
          status: false
        },
        {
          sign: 'other',
          tips: '其他育儿顾问',
          status: false
        }
      ],
      exclusiveNurse: {
        paname: '',
        code: ''
      }
    }
  },
  computed: {
    ...mapState('confirmYuesao', ['depList']),
    ...mapState([
      'confirmProduct',
      'selectedCoupon',
      'selectedWorker',
      'selectedTime',
      'selectedAddress'
    ]),
    expect() {
      return this.depList.find(item => item.id === 'ycq')
    }
  },
  created() {
    // 不获取高级认证孕妇专属育儿，服务顾问都要手动填
    // this.getUserInfo()
  },
  methods: {
    ...mapMutations('confirmYuesao', ['setSelected']),
    ...mapActions('confirmYuesao', ['verificationDepList', 'queryWorkerInfo']),
    selectThis(index) {
      this.selected = this.checkList[index].sign
      this.checkList[index].sign == 'other'
        ? this.cleanInput()
        : this.autoComplete()
    },
    autoComplete() {
      this.fillIn.inviteCode = this.exclusiveNurse.code
      this.fillIn.inviteName = this.exclusiveNurse.paname
    },
    cleanInput() {
      this.fillIn.inviteCode = ''
      this.fillIn.inviteName = ''
    },
    async showExpect() {
      const isValid = await this.verificationDepList('ycq')
      if (isValid) {
        this.$refs.picker.open()
      }
    },
    async getUserInfo() {
      // 获取高级认证孕妇专属育儿
      const { data = {} } = await http.get(
        `${pregantAuthStatusUrl}?skey=${this.$$cookie(
          'skey'
        )}&uid=${this.$$cookie('uid')}`
      )
      const { pregantauthstatus = '' } = data
      if (pregantauthstatus * 1 === 3) {
        this.isAuthPregant = true
        const {
          data: { paname, pauid }
        } = await http.get(userInfoUrl, {
          uid: this.$$cookie('uid'),
          skey: this.$$cookie('skey'),
          padetail: '1',
          pregnant: '1'
        })
        const {
          content: {
            result: { code }
          }
        } = await http.get(`${codeUrl}?uid=${pauid}`)
        this.exclusiveNurse = { paname, code }
        this.autoComplete()
      }
    },
    handlePicker(value) {
      trackClick('SUBMIT_MATERNITY')
      const dateText = utils.dateFormat(value, 'YY-MM-DD')
      this.setSelected({ id: 'ycq', value: dateText })
    },
    handleghInput(event) {
      trackClick('CHOOSE_ADVISER')
      const value = event.target.value
      this.fillIn.inviteCode = value
      if (value) {
        if (value.length === 8 && value.indexOf('19') === 0) {
          this.getYuerGwInfo(value)
        } else {
          this.fillIn.inviteName = ''
        }
      } else {
        this.fillIn.inviteName = ''
      }
    },
    handleLabel(event) {
      trackClick('REMARKS_REMARK')
    },
    async getYuerGwInfo(value) {
      const response = await this.queryWorkerInfo(value)

      if (response && response.code * 1 === 1 && response.data) {
        const res = response.data
        this.fillIn.inviteName = res.workerName
      } else {
        this.fillIn.inviteName = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.price-detail {
  background-color: #fff;
  border-radius: rem(16px);
  ul {
    padding: rem(40px) 0;
    li {
      line-height: rem(32px);
      &:first-child {
        margin-bottom: rem(20px);
      }
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: rem(26px);
        color: #333333;
      }
      .coupon-ui {
        color: #ff395e;
      }
    }
  }
  .item-layout .item-common-content .item-cell-bd {
    p {
      font-weight: bold;
    }
  }
}
.block {
  input {
    line-height: rem(40px);
  }
}
.user-remark-layout-auth {
  padding: rem(30px) rem(18px) rem(24px);
  .item-common-layout-auth {
    font-size: rem(28px);
    border-bottom: 1px solid #f2f2f2;
    .label-ui {
      margin-right: rem(24px);
    }
    .select-label {
    }
    .select-label:nth-child(2) {
      margin-right: rem(30px);
    }
    .ye-gw-ui label {
      // width: auto;
      // display: flex;
      // overflow: hidden;
      // align-items: center;
      input {
        flex: none;
        width: auto;
        margin-left: rem(156px);
        margin-top: rem(29px);
        margin-bottom: rem(30px);
      }
      input[disabled] {
        color: #000;
        opacity: 1;
      }
      .gw-name {
        font-weight: 700;
        flex: auto;
        @include ellicpsis;
      }
      &.hasValue input {
        width: rem(160px);
        font-size: rem(28px);
        margin-right: rem(12px);
        &[type='number'] {
          font-weight: bold;
        }
      }
    }
  }
}

.user-remark-layout {
  padding-right: 0;
  padding-top: rem(22px);
  padding-bottom: rem(18px);
  .item-common-layout {
    .item-common-content {
      .block {
        .label-ui {
          align-items: flex-start;
          padding-top: rem(22px);
        }
      }
    }
  }
}
.user-remark {
  @include border(bottom, #f2f2f2, 0);

  align-items: flex-start;
  textarea {
    text-align: left;
    padding-right: rem(24px);
    padding-top: rem(17px);
    margin-left: 0;
    flex: auto;
    border: 0;
    line-height: rem(38px);
    color: #000000;
    font-size: rem(28px);
  }
}
.invite-code {
  color: #000000;
  font-size: rem(26px);
  input {
    text-align: right;
  }
}
.ye-gw-ui label {
  width: auto;
  display: flex;
  overflow: hidden;
  align-items: center;
  input {
    flex: none;
    width: auto;
  }
  .gw-name {
    flex: auto;
    @include ellicpsis;
  }
  &.hasValue input {
    width: rem(160px);
    &[type='number'] {
      font-weight: bold;
    }
  }
}
.fff {
  color: #999;
}
</style>
